var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"show_header":false,"table_store":_vm.store},scopedSlots:_vm._u([{key:"state",fn:function(ref){
var item = ref.item;
return [_c('data-base-status',{attrs:{"value":item.state}})]}},{key:"selected",fn:function(ref){
var item = ref.item;
return [_c('list-state',{attrs:{"recipients_count":item.recipients_count,"value":item.selected},on:{"click":function($event){return _vm.change_selected(item, $event)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }